import React, { PropTypes } from 'react';
import { Form, Label } from 'semantic-ui-react';
import { Link } from 'react-router';
import { compose, defaultProps, withState, withHandlers } from 'recompose';

import ValidateLogin from '../../../enhancers/ValidateLogin';


const { Input, Button } = Form;

const propTypes = {
  loading: PropTypes.bool,
  buttonLabel: PropTypes.string.isRequired,
  forgottenLink: PropTypes.string.isRequired,
  forgottenLinkText: PropTypes.string.isRequired,
  createLink: PropTypes.string,
  createLinkText: PropTypes.string,
  canCreateOne: PropTypes.bool,
  isEmailValid: PropTypes.bool,
  email: PropTypes.string.isRequired,
  updateEmail: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  emailLabel: PropTypes.string.isRequired,
  validateEmail: PropTypes.func.isRequired,
  emailNotValidMessage: PropTypes.string.isRequired,
  passwordLabel: PropTypes.string.isRequired,
  updatePassword: PropTypes.func.isRequired,
  validatePassword: PropTypes.func.isRequired,
  isPasswordValid: PropTypes.bool,
  submitLogin: PropTypes.func.isRequired,
};

const LoginForm = (props) => {
  const {
    validateEmail,
    validatePassword,
    emailLabel,
    passwordLabel,
    buttonLabel,
    loading,
    forgottenLink,
    forgottenLinkText,
    createLink,
    createLinkText,
    canCreateOne,
    isEmailValid,
    isPasswordValid,
    emailNotValidMessage,
    submitLogin,
    email,
    updateEmail,
    password,
    updatePassword,
  } = props;

  return (
    <Form onSubmit={submitLogin}>
      <Input
        onChange={updateEmail}
        onBlur={validateEmail}
        name="email"
        label={emailLabel}
        type="email"
        value={email}
        error={!isEmailValid}
      />
      {
        !isEmailValid &&
        <Label
          pointing
          basic
          color="red"
          content={emailNotValidMessage}
          style={{ top: '-10' }}
        />
      }
      <Input
        onChange={updatePassword}
        onBlur={validatePassword}
        name="password"
        label={passwordLabel}
        type="password"
        error={!isPasswordValid}
        value={password}
      />
      <Button color="red" loading={loading} floated="right">{buttonLabel}</Button>
      <Link to={forgottenLink}>
        {forgottenLinkText}
      </Link>
      {canCreateOne && <br />}
      {
        canCreateOne &&
        <Link to={createLink}>
          {createLinkText}
        </Link>
      }
    </Form>
  );
};

LoginForm.propTypes = propTypes;

const login = () => console.log('Error:', 'login not provided'); // eslint-disable-line no-console
const enhance = compose(
  defaultProps(
    {
      login,
      buttonLabel: 'OK',
      forgottenLink: '#',
      forgottenLinkText: 'Esqueceu a senha?',
      emailLabel: 'Email',
      passwordLabel: 'Senha',
      emailNotValidMessage: 'Email inválido',
    }
  ),
  withState('isEmailValid', 'emailValidation', true),
  withState('isPasswordValid', 'passwordValidation', true),
  withState('email', 'updateEmail', ''),
  withState('password', 'updatePassword', ''),
  withHandlers(ValidateLogin),
);

export default enhance(LoginForm);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/loginCard/loginForm/LoginForm.js
 **/